module.exports = __webpack_public_path__ + "img/AT0000002401253.eb60de2c.png";